export default __webpack_public_path__ + "static/media/m_kakao_banner.8fad4eec.png";